
import humps from 'humps';
import mqtt from 'mqtt';
import { cashFlowTrendingStore } from "../../modules/CashFlowTrending/store";
import { marketOverviewStore } from "../../modules/MarketOverview/MarketOverviewStore";
import { orderMatchingByPriceStore } from '../../modules/OrderMatchingByPrice/store';
import { stockRankingStore } from "../../modules/StockRanking/store";
import { stockRecommendationStore } from "../../modules/StockRecommendations/store";
import { topStockStore } from "../../modules/TopStock/store";
import Constants from "../constants/Constants";
import HttpStatusCode from '../constants/HttpErrorCode';
import { getRequest } from '../helpers/RequestHelper';
import { IMarketIndex, IStockSymbol, REGISTER_SOCKET_TYPE } from "../model/Model";
import { appStore } from '../store/AppStore';
import { stockDetailStore } from './../../modules/StockDetail/store';
import {APP_REALTIME_WSS_USERNAME, APP_REALTIME_WSS_PASSWORD, APP_REALTIME_WSS_URL, APP_REALTIME_WSS_PORT, APP_REALTIME_WSS_PATH} from '../constants/Config'

class RealtimeEvent {

  options = {
    port: APP_REALTIME_WSS_PORT,
    username: APP_REALTIME_WSS_USERNAME,
    password: APP_REALTIME_WSS_PASSWORD,
    path: APP_REALTIME_WSS_PATH,
  };

  client = mqtt.connect(APP_REALTIME_WSS_URL, this.options);



  listStocks: string[] = [];

  public connect(callback: () => void) {
    this.client.on('connect', () => {
      appStore.isSocketConnected = true;
      callback();
      this.client.on('message', (topic, message) => {
        const data = humps.camelizeKeys([JSON.parse(message.toString())]);
        const type = topic.split('/')[0];
        if (type === 'market') {
          marketOverviewStore.updateMarketOverViewInfo(data as IMarketIndex[]);
          cashFlowTrendingStore.updateMarketSymbold(data as IMarketIndex[]);
        }
        if (type === 'topic') {

          appStore.updateStockSymbol(data as IStockSymbol[]);
          topStockStore.updateStockSymbol(data as IStockSymbol[]);
          cashFlowTrendingStore.updateStockSymbol(data as IStockSymbol[]);
          stockRankingStore.updateMarketOverViewInfo(data as IMarketIndex[]);
          orderMatchingByPriceStore.updateMarketOverViewInfo(data as IMarketIndex[]);
          stockDetailStore.updateStockSymbol(data as IStockSymbol[]);
          stockRecommendationStore.updateStockSymbol(data as IStockSymbol[]);
        }
      });
    });
  }
  isFirstLoad = true;

  public async registerSocket(type: string, data: string) {
    if (this.client.connected) {
      let topic = '';
      if (type === REGISTER_SOCKET_TYPE.RegisShortStockInfo) {
        topic = 'topic';
        const result = await getRequest(`${Constants.API_TRADING_URL}GetLastestStockInfo?stockSymbols=${data.split(',')}`)
        if (result.status < HttpStatusCode.CODE_300) {
          const realTimeInfo = result.body;
          if (realTimeInfo) {
            const data = realTimeInfo;
            appStore.updateStockSymbol(data as IStockSymbol[]);
            topStockStore.updateStockSymbol(data as IStockSymbol[]);
            cashFlowTrendingStore.updateStockSymbol(data as IStockSymbol[]);
            stockRankingStore.updateMarketOverViewInfo(data as IMarketIndex[]);
            orderMatchingByPriceStore.updateMarketOverViewInfo(data as IMarketIndex[]);
            stockDetailStore.updateStockSymbol(data as IStockSymbol[]);
            stockRecommendationStore.updateStockSymbol(data as IStockSymbol[]);
          }
        }
      }
      if (type === REGISTER_SOCKET_TYPE.RegisMarketInfo) {
        if (!this.isFirstLoad) {
          return;
        }
        topic = 'market';
        data.split(',')?.forEach(async (index) => {
          const result = await getRequest(`${Constants.API_TRADING_URL}GetLastestMarketInfo?indexSymbols=${index}`);
          if (result.status < HttpStatusCode.CODE_300) {
            const realTimeInfo = result.body[0];
            this.isFirstLoad = false;
            if (realTimeInfo) {
              const data = [realTimeInfo];
              marketOverviewStore.updateMarketOverViewInfo(data as IMarketIndex[]);
              cashFlowTrendingStore.updateMarketSymbold(data as IMarketIndex[]);
            }
          }
        })
      }

      data.split(',')?.forEach(async (index) => {

        this.client.subscribe(`${topic}.${index}`, (error) => {
          if (error) {
            console.log(`Subscribe to ${topic}.${data} error`, error);
          }
        });
      });
    }
  }

  public checkMatchPrice(data) {
    data.map((item) => {
      if (item.matchPrice === 0) {
        item.matchPrice = item.basicPrice;
      }
      return item;
    });
  }
}

export const realtimeEvent = new RealtimeEvent();
